import React from 'react';
import ViewModuleOutlined from '@mui/icons-material/ViewModuleOutlined';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import ShoppingBagOutlined from '@mui/icons-material/ShoppingBagOutlined';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import { Badge, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import { paths } from '../config/paths';
import { v2Colors } from '../design/theme';
import { useCartItemCount } from '../hooks/useCartItemCount';
import { useV2Common } from '../state/CommonProvider';

export default function BottomNav() {
  const { pathname } = useLocation();
  const { isDesktop } = useV2Common();
  const cartItemCount = useCartItemCount();

  const navValue = (() => {
    if (pathname.includes('/account')) return 3;
    if (pathname.includes('/cart')) return 2;
    if (pathname.includes('/categories')) return 1;
    if (pathname === paths.home) return 0;
    return false;
  })();

  if (isDesktop) return null;

  const cartIcon = (
    <Badge
      color="error"
      max={99}
      badgeContent={cartItemCount}
      invisible={cartItemCount <= 0}
      sx={{
        '& .MuiBadge-badge': {
          fontSize: 10,
          height: 18,
          minWidth: 18,
          top: 2,
          right: 2,
        },
      }}
    >
      <ShoppingBagOutlined />
    </Badge>
  );

  return (
    <Paper
      sx={(theme) => ({
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.drawer,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        backgroundColor: v2Colors.canvas,
      })}
      elevation={3}
    >
      <BottomNavigation value={navValue} showLabels sx={{ bgcolor: v2Colors.canvas }}>
        <BottomNavigationAction label="Home" icon={<HomeOutlined />} component={Link} to={paths.home} />
        <BottomNavigationAction
          label="Categories"
          icon={<ViewModuleOutlined />}
          component={Link}
          to={paths.categories}
        />
        <BottomNavigationAction
          label="Cart"
          icon={cartIcon}
          component={Link}
          to={paths.cart}
        />
        <BottomNavigationAction
          label="Account"
          icon={<PersonOutlineOutlined />}
          component={Link}
          to={paths.account}
        />
      </BottomNavigation>
    </Paper>
  );
}
